(() => {
  'use strict';
  const SELECTOR='[data-vd-category-showcase]';
  function init(root){
    if(!root||root.dataset.vdInitialized==='true')return;
    const track=root.querySelector('[data-vd-track]');
    const prev=root.querySelector('[data-vd-prev]');
    const next=root.querySelector('[data-vd-next]');
    if(!track)return;
    root.dataset.vdInitialized='true';
    root.dataset.vdNavReady='false';
    const cards=()=>Array.from(track.querySelectorAll('.vd-category-showcase__card'));
    const isScrollable=()=>track.scrollWidth>track.clientWidth+3;
    function stepSize(){
      const first=cards()[0];
      if(!first)return track.clientWidth*.9;
      const style=getComputedStyle(track);
      const gap=parseFloat(style.columnGap||style.gap||0);
      return first.getBoundingClientRect().width+gap;
    }
    function updateButtons(){
      if(!prev||!next){
        root.dataset.vdNavReady='true';
        return;
      }

      const scrollable=isScrollable();
      root.classList.toggle('vd-category-showcase--scrollable',scrollable);

      if(!scrollable){
        prev.disabled=true;
        next.disabled=true;
        root.dataset.vdNavReady='true';
        return;
      }

      const max=track.scrollWidth-track.clientWidth;
      prev.disabled=track.scrollLeft<=3;
      next.disabled=track.scrollLeft>=max-3;
      root.dataset.vdNavReady='true';
    }
    prev?.addEventListener('click',()=>track.scrollBy({left:-stepSize(),behavior:'smooth'}));
    next?.addEventListener('click',()=>track.scrollBy({left:stepSize(),behavior:'smooth'}));
    let raf=null;
    track.addEventListener('scroll',()=>{if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(updateButtons)},{passive:true});
    const ro=new ResizeObserver(updateButtons);ro.observe(track);
    updateButtons();
  }
  const initAll=(scope=document)=>scope.querySelectorAll(SELECTOR).forEach(init);
  document.addEventListener('DOMContentLoaded',()=>initAll());
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
